import { render, staticRenderFns } from "./flowSupplierListComponent.vue?vue&type=template&id=22430a13&scoped=true&"
import script from "./flowSupplierListComponent.vue?vue&type=script&lang=js&"
export * from "./flowSupplierListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22430a13",
  null
  
)

export default component.exports